import { useState } from 'react';
import SectionHeading from '../common/SectionHeading';
import { faqs } from '../../data/siteContent';

function FaqSection() {
  const [openFaq, setOpenFaq] = useState(null);

  return (
    <section className="block faq-section">
      <div className="wrap narrow">
        <SectionHeading eyebrow="FAQ" title="자주 묻는 질문" />
        <div className="faq-list reveal">
          {faqs.map(([question, answer], index) => {
            const isOpen = openFaq === index;
            return (
              <div className={isOpen ? 'faq-item open' : 'faq-item'} key={question}>
                <button
                  className="faq-question"
                  type="button"
                  aria-expanded={isOpen}
                  aria-controls={`faq-answer-${index}`}
                  onClick={() => setOpenFaq(isOpen ? null : index)}
                >
                  {question}<span aria-hidden="true">+</span>
                </button>
                <div className="faq-answer" id={`faq-answer-${index}`} aria-hidden={!isOpen}>
                  <div>{answer}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default FaqSection;
